import request from '@/utils/request'

/**
 *获取订单列表
 * @param {*} data 
 */
export function getOrderList(data){
    return request({
        url: '/order/list',
        method: 'post',
        data
    })
}
/**
 *五、获取单条订单信息
 * @param {*} data 
 */
export function getOrderInfo(data){
    return request({
        url: '/order/orderInfo',
        method: 'post',
        data
    })
}
/**
 *六、订单入库(status=2),出库(status=3)
 * @param {*} data 
 */
export function uploadOrderInfo(data){
    return request({
        url: '/order/update',
        method: 'post',
        data
    })
}
/**
 *出入记录
 * @param {*} data 
 */
export function getStoreList(data){
    return request({
        url: '/order/store/list',
        method: 'post',
        data
    })
}
/**
 *十七、获取库存订单
 * @param {*} data 
 */
export function getStoreListProduct(data){
    return request({
        url: '/order/store/products',
        method: 'post',
        data
    })
}
/**
 *修改订单实际价格
 * @param {*} data 
 */
export function updateOrderTotal(data){
    return request({
        url: '/order/updateOrderTotal',
        method: 'post',
        data
    })
}
/**
 *十八、订单合箱
 * @param {*} data 
 */
export function updateBox(data){
    return request({
        url: '/order/updateBox',
        method: 'post',
        data
    })
}

/**
 *创建订单
 * @param {*} data 
 */
export function createOrder(data){
    return request({
        url: '/order/createOrder',
        method: 'post',
        data
    })
}
/**
 *：取消订单
 * @param {*} data 
 */
export function cancelOrder(data){
    return request({
        url: '/order/cancelOrder',
        method: 'post',
        data
    })
}
/**
 *批量生成发货单
 * @param {*} data 
 */
export function sendOrder(data){
    return request({
        url: '/send/order',
        method: 'post',
        data
    })
}
/**
 *获取分页发货列表
 * @param {*} data 
 */
export function sendOrderList(data){
    return request({
        url: '/send/orderList',
        method: 'post',
        data
    })
}
/**
 *获取用户发货列表
 * @param {*} data 
 */
export function sendSerOrders(data){
    return request({
        url: '/send/userOrders',
        method: 'post',
        data
    })
}
/**
 *获取预览客户发货单
 * @param {*} data 
 */
export function sendPreviewOrders(data){
    return request({
        url: '/send/previewOrders',
        method: 'post',
        data
    })
}
/**
 *获取服务器时间
 * @param {*} data 
 */
export function getNowDate(data){
    return request({
        url: '/system/date',
        method: 'post',
        data
    })
}

/**
 *通过快递单号查询订单
 * @param {*} data 
 */
export function searchOrderByExpress(data){
    return request({
        url: '/order/searchOrderByExpress',
        method: 'post',
        data
    })
}

/**
 *快递签收
 * @param {*} data 
 */
export function updateOrderExpress(data){
    return request({
        url: '/order/updateOrderExpress',
        method: 'post',
        data
    })
}

/**
 *补录订单
 * @param {*} data 
 */
 export function orderSupplement(data){
    return request({
        url: '/order/supplement',
        method: 'post',
        data
    })
}

/**
 *补录订单商品
 * @param {*} data 
 */
 export function supplementOrder(data){
    return request({
        url: '/order/supplementOrder',
        method: 'post',
        data
    })
}

/**
*获取用户发货单列表
* @param {*} data 
*/
export function getSendOrderInfo(data){
   return request({
       url: '/send/getSendOrderInfo',
       method: 'post',
       data
   })
}

/**
*用户发货单详情修改额外费用
* @param {*} data 
*/
export function updateExtraInfo(data){
    return request({
        url: '/send/updateExtraInfo',
        method: 'post',
        data
    })
 }

 /**
 *修改发货单的用户名和手机号
 * @param {*} data 
 */
 export function updateDelivery(data){
    return request({
        url: '/delivery/updateDelivery',
        method: 'post',
        data
    })
}

 /**
 *获取发货单的用户名和手机号
 * @param {*} data 
 */
 export function getFeedbackList(data){
    return request({
        url: 'wx/delivery/getDeliveryInfo',
        method: 'post',
        data
    })
} 

/**
*获取用于下拉筛选的批次列表
* @param {*} data 
*/
export function getSelectBatchList(data){
   return request({
       url: '/send/batchNumber',
       method: 'post',
       data
   })
}

/**
*导出国内出库订单
* @param {*} data 
*/
export function exportOutCountryOrder(data){
    return request({
        url: '/order/export',
        method: 'post',
        data
    })
 }
 




// WEBPACK FOOTER //
// ./src/api/order.js